export const API = process.env.REACT_APP_API_URL
export const DISPLAY = process.env.REACT_APP_DISPLAY_URL
export const RENDER = process.env.REACT_APP_API_RENDER
export const MAPKEY = process.env.REACT_APP_MAPKEY
export const VERSION = process.env.REACT_APP_API_VERSION
export const DATAGRIDPROKEY = process.env.REACT_APP_DATAGRID_PRO
